<template>
	<div  :class="[{ 'checked': checked }, {'pl-3': !isAssigned} ]"
		class="checklistItem">
		<div class="checkMarker" @click="() => $emit('toggleComplete', task)" :class="[{'!hidden': !isAssigned}]">
			<church-icon icon="check" />
		</div>

		<div class=" w-full flex ">
			<div class="flex-1 ">

				<div class="checkLabel mt-2" 
					:contenteditable="canEdit"
					v-meditable="{ defaultValue: task?.task_name?.trim() || '' }" 
					placeholder="Task Name"
					@input="(e) => ContentUtils.getContentEditableText(e.target, (text) => (updateTask({ task: text?.trim() })))"></div>

				<div v-if="checked" class="text-sm flex items-center mt-2">
					<span v-if="completedByAvatar(task)"
						class="block w-6 h-6 rounded-full overflow-clip border border-white bg-white mr-2">
						<img :src="completedByAvatar(task)" alt="" class="w-full h-full">
					</span>
					<span class="font-bold">{{ completedByName(task) }}</span>
					<span class="text-gray-1"> - {{ formatDate(task?.date_completed, ) }}</span>
				</div>
			</div>

			<div class="flex "
				@click="() => (viewAssignedUsers(getTaskUsers(task)?.map?.(d =>  { return {...d, type : task?.type, task_wards : task?.select_wards || []} })), $emit('openUserPop'))">

				<template v-for="(mem, i) in getTaskUsers(task, 4)">
					<span :key="i" v-if="!mem.user_profile" :class="[{ '-ml-4': i != 0 }]"
						class="border border-gray rounded-full w-8 h-8 flex items-center justify-center bg-white">
						<church-icon class="!w-4" icon="person-fill" />
					</span>

					<img :key="i + 'img'" v-else-if="i < 5"
						class="w-8 h-8 rounded-full overflow-clip border border-white bg-white"
						:class="[{ '-ml-4': i != 0 }]" :src="Array.isArray(mem.user_profile) && mem.user_profile[0] || mem.user_profile || ''" alt="">
				</template>
				<span v-if="getTaskUsers(task).length > 4"
					class="w-8 h-8 rounded-full overflow-clip border border-white -ml-4 bg-gray flex items-center justify-center">{{
					getTaskUsers(task).length
					- 4}}+</span>
			</div>

			<template v-if="getTaskUsers(task, 4)?.length == 0 && canEdit">
				<button @click="() => $emit('openUserPop')">
					<church-icon icon="plus-circle" />
				</button>
			</template>

			<button v-if="canEdit" class="ml-3" @click.stop="() => $emit('delete', task)">
				<church-icon class="!text-red" icon="trash" />
			</button>

		</div>
	</div>
</template>

<script setup>
/* ========= UTILITIES ====== */
import MeetingApis from '@/apis/meetingApis';
import ContentUtils from '@/helpers/contentUtils';
import DateUtils from '@/helpers/dateUtls';
import StringParser from '@/helpers/stringParser';
import _ from 'lodash';
import { defineProps } from 'vue';


/* ========== PROPS ========== */
const props = defineProps({
	checked: { type: Boolean, default: false },
	task: { type: Object, default: () => {} },
	getTaskUsers: { type: Function, default: () => {} },
	viewAssignedUsers: { type: Function, default: () => {} },
	isAssigned : {type : Boolean, default : false},
	canEdit : {type : Boolean, default : false},
	meeting : {type : Object, default : () => {}},
})

/* =========== COMPUTED ===== */

/**
 * Get the name of the user who completed the task
 */
const completedByName = () => {
	return props.task?.completed_by?.user_firstname + ' ' + props.task?.completed_by?.user_lastname ||  props.task?.completed_by?.display_name || '';
}

/**
 * Get the avatar of the user who completed the task
 */
 const completedByAvatar = () => {
	const task = props.task
	if(!task?.completed_by) return ''
	if(task) {
		let user = ''
		StringParser.extractUrl({string : task?.completed_by?.user_avatar, callback: url =>  user = _.last(url)})
		return user
	} return ''
}


/* ========= METHODS ===== */

/**
 * Format date
 * @param {String} date 
 */
/**
 * Format date
 * @param {String} date
 */
 const formatDate = (date) => {
	return DateUtils.dateFormat({date, format : 'MMMM DD, YYYY', options : {originDateFormat : 'DD/MM/YYYY'}})
}	

/**
 * Update task
 * @param {Object} data 
 */
const updateTask =  _.debounce((data) => {
	if(!data) return
	const params = {
		meeting_id : props.meeting?.id,
		task_id : props.task?.task_id,
		...data
	}
	MeetingApis.updateTask({params, callback : (data) => {
		console.log('update task', data)
	}})
}, 500)

</script>

